import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import Close from "../icons/Close";
import ArrowLeft from "../icons/ArrowLeft";

import {
    colors,
    Section,
    Grid,
    Row,
    Col,
    H2,
    fullWidthStyles,
    Flexbox,
    GrayButton,
    A
} from "../shared";

export const ArrowLeftIcon = styled(ArrowLeft)`
    cursor: pointer;
`;

export const CloseIcon = styled(Close)`
    width: 1.25rem;
    cursor: pointer;
`;

export const HeaderContent = styled(Flexbox)``;

export const Header = styled(Section)`
    ${fullWidthStyles}
    background-color: ${colors.whiteDuplicate};
    padding-top: 1.1875rem;
    padding-bottom: 1.1875rem;
    border-bottom: 1px solid ${colors.brownishGreyTwo};
`;

export const linkHeadingStyles = css`
    padding-top: 1.3125rem;
    padding-bottom: 0.8125rem;
    color: ${colors.brownishGreyTwo};
`;

let ItemHeading = ({ className, children }) => (
    <Section className={className}>
        <ContainedGrid>
            <H2 size={12}>{children}</H2>
        </ContainedGrid>
    </Section>
);

ItemHeading = styled(ItemHeading)`
    ${linkHeadingStyles}
`;
export { ItemHeading };

let ContainedGrid = ({ children, className }) => (
    <Grid className={className}>
        <Row>
            <Col sm={12}>{children}</Col>
        </Row>
    </Grid>
);

ContainedGrid = styled(ContainedGrid)``;
export { ContainedGrid };

const Team = styled(A)`
    padding-top: 0.625rem;
`;

let Teams = ({ teams, className }) => (
    <div className={className}>
        {teams.map(team => (
            <Team
                key={team.username}
                href={`/${team.username}/settings/seats/`}
            >
                {team.name}
            </Team>
        ))}
    </div>
);

Teams = styled(Teams)``;

Teams.propTypes = {
    teams: PropTypes.array
};

export { Teams };

export const itemStyles = css`
    background-color: ${colors.whiteDuplicate};
    ${fullWidthStyles}
    margin-bottom: 0.25rem;

    a {
        text-decoration: none;
        display: block;
        color: ${colors.black};

        &:hover {
            color: ${colors.charcoalGrey};
        }
    }

    ${Section} {
        ${fullWidthStyles}
        padding-top: 0.8125rem;
        padding-bottom: 0.75rem;
    }
`;

let Item = ({ children, className, noLink, ...anchorProps }) => {
    return (
        <li className={className}>
            {noLink ? (
                <Section>
                    <ContainedGrid>{children}</ContainedGrid>
                </Section>
            ) : (
                <A {...anchorProps}>
                    <Section>
                        <ContainedGrid>{children}</ContainedGrid>
                    </Section>
                </A>
            )}
        </li>
    );
};

Item = styled(Item)`
    ${itemStyles}
`;

Item.propTypes = {
    href: PropTypes.string,
    noLink: PropTypes.bool,
    onClick: PropTypes.func
};

export { Item };

export const Items = styled.ul``;

export const openMobileMenuStyles = css`
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const LogOutButton = styled(GrayButton)``;

export const Wrapper = styled.div`
    height: 100vh;
    background-color: ${colors.veryLightPink};
    color: ${colors.black};

    ${LogOutButton} {
        margin: 1rem 0;
    }
`;

// for iOS scrolling:
export const MobileSpacing = styled.div`
    height: 125px;
`;
